import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const AccountSteps = styled.div`
  display: block;
  margin-top: 30px;
`;
export const ButtonsPanelRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 -10px;

  @media (max-width: 1600px) {
    margin: 0 -5px;
  }
  @media (max-width: 1360px) {
    margin: 0 -4px 0;
  }

  & > * {
    margin: 5px 10px;
    @media (max-width: 1600px) {
      margin: 5px;
    }
    @media (max-width: 1360px) {
      margin: 5px 4px;
    }
    &.Dark {
      min-width: 154px;
    }
    &.OutOfStock {
      min-width: 154px;
    }
    &.Hidden,
    &.Delete {
      min-width: 126px;
      @media (max-width: 1600px) {
        min-width: 110px;
      }
      @media (max-width: 1360px) {
        min-width: 100px;
      }
    }
  }
`;

export const MenuEditorPublish = styled.div`
  position: relative;

  &.PublishOverlay {
    z-index: 13;
  }
  .PublishDrop {
    &::after {
      right: 145px;
      @media (max-width: 1650px) {
        right: 98px;
      }
    }
  }
  @media (max-width: 767px) {
    .PublishDrop {
      right: inherit;
      left: -15px;

      &::after {
        right: inherit;
        left: 80px;
      }
    }
  }
  @media (max-width: 599px) {
    .PublishDrop {
      right: inherit;
      left: 0;

      &::after {
        right: inherit;
        left: 70px;
      }
    }
  }
  @media (max-width: 470px) {
    .PublishDrop {
      left: 50%;
      transform: translateX(-50%);
      &::after {
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
`;

export const DgDCheckbox = styled.div`
  position: absolute;
  top: 19px;
  left: -10px;
  pointer-events: auto;
  @media (max-width: 1000px) {
    left: 0;
    top: 15px;
  }
`;

export const ReplaceAllAdjustmentsButton = styled.div`
  margin: 20px 0;
  display: flex;
  justify-content: flex-end;
`;

export const AdjustmentsContainer = styled.div`
  margin-top: 20px;
`;

export const AdjustmentHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
`;

export const AdjustmentItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background-color: #f7f7fa;
  border-radius: 6px;
  margin-bottom: 10px;
`;

export const AdjustmentInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
`;

export const AdjustmentText = styled.span`
  font-size: 14px;
  color: #2f3d48;
  font-weight: 500;
  .bold {
    font-weight: 700;
  }
`;

export const AdjustmentValue = styled.span`
  font-size: 14px;
  color: #ff2d38;
  font-weight: 600;
`;
